<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">住户名称：</span>
        </div>
        <el-input v-model="formData.enterpriseName" size="small" style="width: 280px" disabled />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">合同编号：</span>
        </div>
        <el-input v-model="formData.contractCode" size="small" style="width: 280px" disabled />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">应缴金额：</span>
        </div>
        <el-input v-model="formData.payMoney" size="small" style="width: 280px" disabled />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">缴费截止时间：</span>
        </div>
        <el-input v-model="formData.payDeadline" size="small" style="width: 280px" disabled />
      </div>

      <!--<div class="form-line">-->
        <!--<div class="textBox">-->
          <!--<b class="red">*</b>-->
          <!--<span class="line-text">截止天数(倒计时)：</span>-->
        <!--</div>-->
        <!--<el-input v-model="formData.payDeadCount" size="small" style="width: 280px" disabled />-->
      <!--</div>-->

      <div class="form-line" >
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">缴费渠道：</span>
        </div>
        <el-select v-model="formData.payChannel" placeholder="请选择" size="small" style="width: 280px" disabled>
          <el-option
            v-for="item in payChannelModifyList"
            :key="item.key"
            :label="item.label"
            :value="item.key">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">缴费状态：</span>
        </div>
        <el-select v-model="formData.payStatus" placeholder="请选择" size="small" style="width: 280px" disabled>
          <el-option
            v-for="item in payStatusModifyList"
            :key="item.key"
            :label="item.label"
            :value="item.key">
          </el-option>
        </el-select>
      </div>

      <div class="form-line" v-if="formData.payStatus === '1'">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">缴费日期：</span>
        </div>
        <el-date-picker
          v-model="formData.payTime"
          type="datetime"
          size="small"
          style="width: 280px"
          :editable=false
          disabled
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择日期">
        </el-date-picker>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">发票状态：</span>
        </div>
        <el-select v-model="formData.invoiceStatus" placeholder="请选择" size="small" style="width: 280px">
          <el-option
            v-for="item in invoiceStatusModifyList"
            :key="item.key"
            :label="item.label"
            :value="item.key">
          </el-option>
        </el-select>
      </div>

      <div class="form-line" v-if="formData.invoiceStatus === '1'">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">开票日期：</span>
        </div>
        <el-date-picker
          v-model="formData.invoiceTime"
          type="date"
          size="small"
          style="width: 280px"
          :editable=false
          value-format="yyyy-MM-dd"
          placeholder="选择日期">
        </el-date-picker>
      </div>


      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import {errorHandler} from '../../../utils/errorHandler'
  import {api} from '../../api/Finance'
  import {nError, nSuccess} from '../../../utils/notice'
  import ButtonConfirmNext from '../../../components/Button/ButtonConfirmNext'

  export default {
    components: {
      ButtonConfirmNext,
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'property-modify',
    data () {
      return {
        breadcrumb: [{
          value: '智慧财务',
          name: 'finance-over-view'
        }, {
          value: '物业费账单'
        }],
        mainTitle: '修改物业费',
        subheading: '修改物业费信息',
        payChannelModifyList: [{
          key: '1',
          label: '微信'
        }, {
          key: '2',
          label: '支付宝'
        }, {
          key: '3',
          label: '银行转账'
        }, {
          key: '4',
          label: '现金'
        }, {
          key: '5',
          label: '其他'
        }],
        payStatusModifyList: [{
          key: '0',
          label: '未缴费'
        }, {
          key: '1',
          label: '已缴费'
        }, {
          key: '3',
          label: '已缴费--变更'
        }, {
          key: '4',
          label: '未缴费--变更'
        }, {
          key: '6',
          label: '审批中'
        }],
        invoiceStatusModifyList: [{
          key: '0',
          label: '未开票'
        }, {
          key: '1',
          label: '已开票'
        }, {
          key: '2',
          label: '开票中'
        }],
        formData: {}
      }
    },
    created () {
      this.currentCode = this.$route.params.id
      this.getPropertyByCode()
    },
    methods: {
      toPropertyManagement () {
        this.$router.push({
          name: 'property-finance'
        })
      },
      getPropertyByCode () {
        this.$axios.get(`${api.getPayItemDetailByCode}/${this.currentCode}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              this.formData = res.data.data
            }
          })
          .catch(errorHandler('查询信息失败'))
      },
      confirm () {
        if (this.formData.payStatus === '1' && !this.formData.payTime) {
          nError('请输入缴费日期')
          return
        }
        if (this.formData.invoiceStatus === '1' && !this.formData.invoiceTime) {
          nError('请输入开票日期')
          return
        }
        this.$axios.post(api.updatePayItemDetailByCode, this.formData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('修改成功')
              this.toPropertyManagement()
            }
          })
          .catch(errorHandler('修改失败'))
      },
      cancel () {
        this.toPropertyManagement()
      }
    }
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
  }
  .form-line {
    margin: 20px 0;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 180px;
    line-height: 32px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin: 40px 0;
    display: flex;
    justify-content: space-between;
  }
</style>

<style lang="less">
  .el-input--mini .el-input__inner {
    height: 32px;
    line-height: 32px;
  }
</style>



// WEBPACK FOOTER //
// src/view/Finance/InvestmentFinance/propertyFinanceModify.vue